"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavDevViewSection = void 0;
const syntax_highlight_json_1 = require("@app/util/syntax-highlight-json");
const react_1 = __importDefault(require("react"));
const unavailability_context_1 = require("../unavailability-context");
const UnavDevViewSection = () => {
    const { formControl, ...context } = (0, unavailability_context_1.useUnavailability)();
    return (react_1.default.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', flexFlow: 'column' } },
        react_1.default.createElement(syntax_highlight_json_1.SyntaxHighlightJSON, { json: JSON.stringify({
                form: context.getValues(),
                context: (0, syntax_highlight_json_1.stripJSONObject)(context),
            }, null, 2) })));
};
exports.UnavDevViewSection = UnavDevViewSection;
